
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/working-with-an-agent",
      function () {
        return require("private-next-pages/working-with-an-agent.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/working-with-an-agent"])
      });
    }
  